import { Phase1, AgFinancingEvaluationType, AgFinancingDebtType, Credit, Phase2, Detail } from '@indigo-ag/schema';
import { SelectOption } from '@indigo-ag/component-module';
import i18next from 'core/i18n';

export const evaluationTypesOptions: SelectOption<AgFinancingEvaluationType>[] = [
  { name: i18next.t('evaluationTypeClear'), value: AgFinancingEvaluationType.CLEAR },
  { name: i18next.t('evaluationTypeDenied'), value: AgFinancingEvaluationType.DENIED }
];

export const debtTypesOptions: SelectOption<AgFinancingDebtType>[] = [
  { name: i18next.t('bank'), value: AgFinancingDebtType.BANK },
  { name: i18next.t('agFinance'), value: AgFinancingDebtType.AG_FINANCE },
  { name: i18next.t('other'), value: AgFinancingDebtType.OTHER },
  { name: i18next.t('serasa'), value: AgFinancingDebtType.SERASA }
];

// * Phase 1 - Commercial
export interface IIbamaInfo {
  ibamaEvaluation?: Phase1['ibamaEvaluation'];
  ibamaNotes?: Phase1['ibamaNotes'];
  ibamaFiles?: Phase1['files'];
}

export interface ISerasaInfo {
  serasaEvaluation?: Phase1['serasaEvaluation'];
  serasa?: Phase1['serasa'];
  serasaNotes?: Phase1['serasaNotes'];
  serasaFiles?: Phase1['files'];
}

export interface ILaborInfo {
  laborEvaluation?: Phase1['laborEvaluation'];
}

export interface IStateJudicialCheckInfo {
  stateJudicialCheckEvaluation?: Phase1['stateJudicialCheckEvaluation'];
  stateJudicialCheck?: Phase1['stateJudicialCheck'];
  stateJudicialCheckNotes?: Phase1['stateJudicialCheckNotes'];
  stateJudicialCheckFiles?: Phase1['files'];
}

export interface IDecisionInfo {
  status: Phase1['status'];
  notes: Phase1['notes'];
  decisionBy: Phase1['decisionBy'];
  decisionAt: Phase1['decisionAt'];
}

// * Phase 2 - FLC
export interface IParticipationInfo {
  shareholderPartner: Credit['shareholderPartner'];
  shareholderCompany: Credit['shareholderCompany'];
}

export interface IClientData {
  customerActivityType: Credit['customerActivityType'];
  customerProducts: Credit['customerProducts'];
  customerDescription: Credit['customerDescription'];
}

export interface ISerasaDebt {
  amount: number;
  name: string;
  type: AgFinancingDebtType;
  contact?: string;
  count?: number;
  details?: Detail[];
}

export interface IPesquisaSerasaInfo {
  serasaConsultationDate?: Credit['serasaConsultationDate'];
  serasaObservation?: Credit['serasaObservation'];
  serasaDebts?: ISerasaDebt[];
  files?: Credit['files'];
}

export interface IIncomeStatementInfo {
  returnOfIncomeCosting: Credit['returnOfIncomeCosting'];
  returnOfIncomeDebts: Credit['returnOfIncomeDebts'];
  returnOfIncomeGrossRevenue: Credit['returnOfIncomeGrossRevenue'];
  returnOfIncomeInvestment: Credit['returnOfIncomeInvestment'];
  returnOfIncomePatrimony: Credit['returnOfIncomePatrimony'];
  returnOfIncomeResult: Credit['returnOfIncomeResult'];
  returnOfIncomeRural: Credit['returnOfIncomeRural'];
  returnOfIncomeTaxableIncome: Credit['returnOfIncomeTaxableIncome'];
  returnOfIncomeUrban: Credit['returnOfIncomeUrban'];
  returnOfIncomeYearIRPF: Credit['returnOfIncomeYearIRPF'];
  returnOfIncomeExploredAreaCode: Credit['returnOfIncomeExploredAreaCode'];
  returnOfIncomeExploredHectares: Credit['returnOfIncomeExploredHectares'];
}

export interface IExploredAreasInfo {
  exploredAreas: Credit['exploredAreas'];
}

export interface IFinancialInformation {
  financialPendency: Credit['financialPendency'];
  debtSituation: Credit['debtSituation'];
  financialInformation: Credit['financialInformation'];
}

export interface IConsultingScore {
  scoreNumber: Credit['scoreNumber'];
  scoreType: Credit['scoreType'];
}

export interface INotes {
  creditOpinion: Credit['creditOpinion'];
  legalOpinion: Credit['legalOpinion'];
}

export interface IJudicialActionsInfo {
  judicialActions: Credit['judicialActions'];
}

// * Phase 2 - Luchesi
export interface ICollateralAnalysisInfo {
  matriculas: Phase2['matriculas'];
}
